import { render, staticRenderFns } from "./inflections-table-prerendered.vue?vue&type=template&id=9fbfc2b2&"
import script from "./inflections-table-prerendered.vue?vue&type=script&lang=js&"
export * from "./inflections-table-prerendered.vue?vue&type=script&lang=js&"
import style0 from "./inflections-table-prerendered.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/alpheios-core/alpheios-core/packages/components/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9fbfc2b2')) {
      api.createRecord('9fbfc2b2', component.options)
    } else {
      api.reload('9fbfc2b2', component.options)
    }
    module.hot.accept("./inflections-table-prerendered.vue?vue&type=template&id=9fbfc2b2&", function () {
      api.rerender('9fbfc2b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/components/inflections/inflections-table-prerendered.vue"
export default component.exports